import { IconImageInPicture } from "@tabler/icons-react";

import { useCrosswordStore } from "@/store";

export function ChangeImageSizeButton() {
  const imageSize = useCrosswordStore.use.imageSize();
  const setImageSize = useCrosswordStore.use.setImageSize();
  const useImagesIfAvailable = useCrosswordStore.use.useImagesIfAvailable();

  if (!useImagesIfAvailable) {
    return null;
  }

  const handleClick = () => {
    setImageSize(imageSize === "compact" ? "full" : "compact");
  };

  return (
    <button
      className="flex h-10 cursor-pointer items-center gap-1 rounded-[20px] bg-[#329DA7] px-3 text-white hover:bg-[#228690] disabled:cursor-default disabled:bg-[#42576ec4]"
      onClick={handleClick}
    >
      <span className="hidden xl:block">{t("Image size")}</span>
      <IconImageInPicture />
    </button>
  );
}
